import { useCallback, useContext } from 'react';
import { ThemeContext } from '../providers';
import { actions as optionActions } from '@susu/custom-made/providers/reducers/option';
import { ConfigurationTypes } from '../utils/productDefinition';
import { Clients } from '../utils/constants';
import { getAvoEventParamsWithOption } from '../utils/utils';
import Avo from '@susu/custom-made/Avo';
import { useMissingValues } from './useMissingValues';

export const useAdditionalProduct = () => {
  const { dispatch, state } = useContext(ThemeContext);
  const { removeConfigurationOptionValuesFromMissingValues } = useMissingValues();

  const addAdditionalProductHandler = useCallback(
    (affectedConfigurationTypeId: ConfigurationTypes) => {
      dispatch({
        type: optionActions.ADD_REMOVE_ADDITIONAL_PRODUCT,
        payload: {
          configurationType: affectedConfigurationTypeId,
          isAdded: true,
        },
      });

      state.client === Clients.onLine &&
        Avo.custommadeAddAdditionalProduct(getAvoEventParamsWithOption(state, state.section ?? ''));
    },
    [dispatch, state],
  );

  const removeAdditionalProductHandler = useCallback(
    (affectedConfigurationTypeId: ConfigurationTypes) => {
      dispatch({
        type: optionActions.ADD_REMOVE_ADDITIONAL_PRODUCT,
        payload: {
          configurationType: affectedConfigurationTypeId,
          isAdded: false,
        },
      });

      removeConfigurationOptionValuesFromMissingValues(affectedConfigurationTypeId);
    },
    [dispatch],
  );

  return { addAdditionalProductHandler, removeAdditionalProductHandler };
};
